import React from 'react';
import { useTheme } from '@pinwheel/origami';
import { MODAL_CONTENT_CONTAINER_ID } from './hooks/useScreenHeaderFocus';
import ExitOverlay from './components/ExitOverlay';
import ExitConfirmationMux from './views/ExitConfirmationMux';
import useShowingExitConfirmation from './hooks/useShowingExitConfirmation';
import BottomSheet from './components/BottomSheet/BottomSheet';
// Simple wrapper over the modal contents which provides some preliminary
// styling and also handles the rendering of the exit confirmation.
var ModalContentWrapper = function (_a) {
    var children = _a.children;
    var resolveColor = useTheme().resolveColor;
    var showingExitConfirmation = useShowingExitConfirmation().showingExitConfirmation;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { id: MODAL_CONTENT_CONTAINER_ID, className: "pinwheel-link-modal", 
            // Hide the screen content whenever the exit confirmation is overlaid so
            // that this non-visible "background" content will also not be read by
            // screen readers (accessibility/WCAG).
            hidden: showingExitConfirmation, style: {
                color: resolveColor({
                    type: 'theme',
                    colorLegacy: 'Neutral/80',
                    colorNext: 'neutral/default',
                }),
            } }, children),
        showingExitConfirmation && (React.createElement(ExitOverlay, null,
            React.createElement(ExitConfirmationMux, null))),
        React.createElement(BottomSheet, null)));
};
export default ModalContentWrapper;
